import React from "react";

const MIN_STAFF = 6;
const OVERSTAFF_THRESHOLD = 6;

/**
 * Returns the CSS colour modifier for a cell.
 * present = total staff present on that date for this gym.
 * hasData = false when date is in the future or no shift data exists.
 */
export const getCellColour = (present, hasData) => {
  if (!hasData) return "neutral";
  if (present === 0)                     return "red";
  if (present > OVERSTAFF_THRESHOLD)     return "purple";
  if (present >= MIN_STAFF)              return "green";
  return "yellow";
};

const MatrixCell = ({ present, hasData, isActive, onClick }) => {
  const colour = getCellColour(present, hasData);
  const isClickable = hasData && !!onClick;

  return (
    <td>
      <span
        className={`sdm-cell sdm-cell--${colour}${isActive ? " sdm-cell--active" : ""}`}
        onClick={isClickable ? onClick : undefined}
        role={isClickable ? "button" : undefined}
        tabIndex={isClickable ? 0 : undefined}
        onKeyDown={isClickable ? (e) => (e.key === "Enter" || e.key === " ") && onClick() : undefined}
        aria-label={hasData ? `${present} staff present` : "No data"}
        aria-pressed={isClickable ? !!isActive : undefined}
      >
        {hasData ? present : ""}
      </span>
    </td>
  );
};

export default MatrixCell;
